export default function selectGitHubLoading(state) {
  return state.integrations.thirdPartyData.github.loading
}
